// extracted by mini-css-extract-plugin
export default {"cardGrid":"CardGrid_cardGrid__4RtWe","accordionBody":"CardGrid_accordionBody__nFOcT","socialIcons":"CardGrid_socialIcons__7Byrc","accordionHeader":"CardGrid_accordionHeader__pqC1t"};